
import User from "@/types/User";
import { computed, defineComponent, PropType } from "vue";
import PeoplePicker from "@/Components/Controls/PeoplePicker.vue";
import UserPill from "@/Components/Shared/UserPill.vue";

export default defineComponent({
  components: { UserPill, PeoplePicker },
  props: {
    allUsers: {
      type: Object as PropType<User[]>,
      required: true,
    },
    modelValue: {
      type: Object as PropType<number[]>,
      default: () => [],
    },
    shownUsers: {
      type: Object as PropType<User[]>,
      default: () => [],
    },
    mode: {
      type: String,
      default: () => "view",
      validator: (value: string) => {
        return ["view", "edit"].indexOf(value) !== -1;
      },
    },
  },
  emits: ["update:modelValue"],
  setup(props, context) {
    const value = computed({
      get: () => props.modelValue,
      set: (v) => {
        context.emit("update:modelValue", v);
      },
    });

    return {
      value,
    };
  },
});
